import {
  DocumentSignaturesStatus,
  DocumentStatus,
  RequestStatus,
  StepStatus,
} from '@/api/types/enums';

/** Tag/Chip color palette used across status and team-type tags. */
export const TagColor = {
  dark: 'dark',
  green: 'green',
  blue: 'blue',
  orange: 'orange',
  red: 'red',
  yellow: 'yellow',
  purple: 'purple',
} as const;

export type TagColor = (typeof TagColor)[keyof typeof TagColor];

/** Maps a request/document/step status value to its tag color. */
export const STATUS_COLORS: Record<string, TagColor> = {
  [RequestStatus.REQUESTED]: TagColor.dark,
  [RequestStatus.SENT]: TagColor.blue,
  [RequestStatus.APPROVED]: TagColor.green,
  [RequestStatus.REJECTED]: TagColor.orange,
  [DocumentStatus.missing_signature]: TagColor.orange,
  [DocumentSignaturesStatus.unsigned]: TagColor.orange,
  [DocumentSignaturesStatus.failed]: TagColor.red,
  [DocumentSignaturesStatus.signed]: TagColor.green,
  [StepStatus.done]: TagColor.green,
  [StepStatus.in_progress]: TagColor.blue,
  [StepStatus.not_started]: TagColor.dark,
  [StepStatus.not_required]: TagColor.purple,
  [StepStatus.pending]: TagColor.yellow,
  [StepStatus.blocked]: TagColor.red,
};
